var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",domProps:{"innerHTML":_vm._s(require('@web/assets/splash_screen/bubble_outline.svg'))}})}
var staticRenderFns = []

export { render, staticRenderFns }